(function (angular, app) {
   "use strict";

   angular.module(app.modules.common.name)
       .constant(app.modules.common.constants.themelist,
        
       [
         {themeId: 1 , Name : "None", className : ""} 
         ,{themeId: 2 , Name : "Ocean", className : "theme-ocean"}
         //, { themeId: 3, Name: "Lakes", className: "theme-lakes" }
         , { themeId: 4, Name: "Wooded", className: "theme-wooded" }
         , { themeId: 5, Name: "Desert", className: "theme-desert" }
         , { themeId: 6, Name: "Links", className: "theme-links" }
         , { themeId: 7, Name: "City View", className: "theme-city" }
         , { themeId: 8, Name: "Mountains", className: "theme-mountain" }
         , { themeId: 9, Name: "Big Sky", className: "theme-bigsky" }
         , { themeId: 10, Name: "Tropical", className: "theme-tropical" }
         , { themeId: 11, Name: "Island", className: "theme-island" }
         , { themeId: 12, Name: "Hill Country", className: "theme-hillcountry" }
         , { themeId: 13, Name: "Walkers", className: "theme-walkers" }
         , { themeId: 14, Name: "Tee It Up", className: "theme-teeitup" }
         , { themeId: 15, Name: "Bucket of Balls", className: "theme-bucket" }
         , { themeId: 16, Name: "Golf Lessons", className: "theme-lessons" }
       ]
        
       );
}(angular, app));

/*
delete from grpTheme
insert into grpTheme (grpThemeID, Name) values (1, 'None')
insert into grpTheme (grpThemeID, Name) values (2, 'Ocean')
insert into grpTheme (grpThemeID, Name) values (3, 'Lakes')
insert into grpTheme (grpThemeID, Name) values (4, 'Wooded')
insert into grpTheme (grpThemeID, Name) values (5, 'Desert')
insert into grpTheme (grpThemeID, Name) values (6, 'Links')
insert into grpTheme (grpThemeID, Name) values (7, 'City View')
insert into grpTheme (grpThemeID, Name) values (8, 'Mountains')
insert into grpTheme (grpThemeID, Name) values (9, 'Big Sky')
insert into grpTheme (grpThemeID, Name) values (10, 'Tropical')
insert into grpTheme (grpThemeID, Name) values (11, 'Island')
insert into grpTheme (grpThemeID, Name) values (12, 'Hill Country')
insert into grpTheme (grpThemeID, Name) values (13, 'Walkers')
insert into grpTheme (grpThemeID, Name) values (14, 'Tee It Up')
insert into grpTheme (grpThemeID, Name) values (15, 'Bucket of Balls')
insert into grpTheme (grpThemeID, Name) values (16, 'Golf Lessons')


*/


